import { AuthContext } from '../../contexts/auth'; 
import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
// import { atualizarCompartimento, excluirCompartimento, localizarCompartimento, incluirCompartimento, listarFluidos } from '../../services/api';
import  { cryptRC4, toHexDump }  from '../../services/funcoes';
import { dataHoraAtualBrasileira, formatarData2 } from '../../services/datautils';

import { toast } from 'react-toastify';
import Globais from '../../components/Globais/Globais'; 

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';
import Footer from '../../components/Footer/footer';

export default function GerarSenha({funcao}){
  const { clienteId, identificador, ligaMenu } = useContext(AuthContext);
  const history = useNavigate();
  // const[cliente, setCliente] = useState(0);
  // const[identificador, setIdentificador] = useState(null);
  const[intervalo, setIntervalor] = useState('M');
  const[validade, setValidade] = useState(0);
  const[senha, setSenha]= useState(null);

  useEffect(()=>{
    
  }, []);

  // function handleChangeCliente (e) {
  //   const indice = e.target.value;
  //   const identificador = clientes[indice].idt_cliente;
  //   setCliente(indice);
  //   setIdentificador(identificador);
  // };

  function senhaGerada(e) {
    toast.success('Senha Gerada com sucesso!');
  }

  async function executaAcao(e){
    e.preventDefault();

    console.log('Parâmetros: ', identificador, validade, intervalo);
    if (!identificador) {
      toast.error('Selecione um cliente');
      return;
    }

    if (!validade || validade === 0) {
      toast.error('Informe um valor para Validade');
      return;
    }

    if (intervalo === '') {
      toast.error('Selecione Minutos ou Horas de validade');
      return;
    }

    const dataAtual = dataHoraAtualBrasileira() + ':00';
    // console.log('Data Atual: ', dataAtual);
    const dataFormatada = formatarData2(dataAtual, 'aaaammdd');
    // console.log('Data Formatada: ', dataFormatada);
    const lsPalavra = identificador + dataFormatada //'JG-0000720251027'; JG-0000720251027
    // console.log('Palavra: ', lsPalavra);
    const texto = formatarData2(dataAtual, 'hhmin') + intervalo + validade.padStart(3, "0");
    // console.log('Hora minuto: ', formatarData2(dataAtual, 'hhmin'));
    // console.log('Texto: ', texto);
    const lsSenha = toHexDump(cryptRC4(texto, lsPalavra));
    // console.log('Senha: ', lsSenha);

    setSenha(lsSenha);
    toast.success('Senha gerada com sucesso!');
    return;
  }

  function handleSair(e){
   history('/principal');
  }

  return(
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />

      <main>
        <Titulo tela={'Conceder Permissão'} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />

          <section className='p-4 h-full'>
            <form method='POST' action={handleSair} id='form-geral' className='form-geral'>
              <h3 className='font-semibold text-lg mb-3 mt-1'>Conceder Permissão</h3>
              {/* <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="combo-container">
                  <span>
                    <label className="combo-label">Cliente: </label>
                    <select className="combo-select" value={cliente} onChange={(e) => handleChangeCliente(e)} >
                        {clientes.map((item, index) => {
                          return(
                            <option key={item.cod_cliente} value={index}>
                              {item.idt_cliente} - {item.nom_cliente}
                            </option>
                          )
                        })}
                    </select>
                  </span>
                </div>
              </div> */}

              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group md:mb-3">
                  <label className="combo-label">validade: </label>
                  <div className="single-input">
                    <input 
                      type="text" 
                      id='validade' 
                      name='validade' 
                      placeholder={'Quantidade'}
                      className='w-full p-2 border border-gray-300 rounded-md' 
                      autocomplete='validade' 
                      value={validade} 
                      onChange={(e) => setValidade(e.target.value)}
                      required 
                    />
                  </div>
                </div>
              </div>

              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group mb-3">
                  <h4 className='font-semibold text-sm mb-3'></h4>
                  <div className='flex items-center gap-2'>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='minutos' 
                        name='minutos' 
                        value='M' 
                        onChange={(e) => setIntervalor(e.target.value)} 
                        checked={intervalo === 'M'}
                      /> 
                      <label for="minutos" className='mb-0'>Minutos</label>
                    </div>
                    <div className="single-input flex items-center">
                      <input 
                        type="radio" 
                        id='horas' 
                        name='horas' 
                        value='H' 
                        onChange={(e) => setIntervalor(e.target.value)} 
                        checked={intervalo === 'H'}
                      /> 
                      <label for="horas">Horas</label>
                    </div>
                  </div>
                </div>
              </div>
            
              <div className="row grid md:grid-cols-3 grid-cols-1 md:gap-4 gap-2">
                <div className="input-group md:mb-3">
                  <label className="combo-label">Senha: </label>
                  <div className="single-input">
                    <input 
                      type="text" 
                      id='senha' 
                      name='senha' 
                      placeholder={'Senha'}
                      className='w-full p-2 border border-gray-300 rounded-md' 
                      autocomplete='senha' 
                      value={senha} 
                      onChange={(e) => senhaGerada()} 
                      readOnly 
                    />
                  </div>
                </div>
              </div>

              <Footer funcao='GerarSenha' executa={executaAcao} sair={handleSair} />
            </form>
          </section>
        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>
  )
}
